<template>
  <div>
    <d-header></d-header>
    <div class="view-container">
      <PlaceHolder class="placeholder animated" v-show="isShowPlaceholder" transition="fade"></PlaceHolder>
      <router-view transition="trans"></router-view>
    </div>
    <d-footer style="overflow: hidden;"></d-footer>
    <scroll-to-top></scroll-to-top>
  </div>
</template>

<script>
import DHeader from './components/DHeader'
import DFooter from './components/DFooter'
import ScrollToTop from './components/ScrollToTop'
import Placeholder from './components/Placeholder'

export default {
  components: {
    DHeader,
    DFooter,
    ScrollToTop,
    Placeholder
  },
  data () {
    return {
      isShowPlaceholder: false
    }
  },
  transitions: {
    trans: {
      beforeEnter (el) {
        this.isShowPlaceholder = true
      },
      afterEnter (el) {
        setTimeout(() => {
          this.isShowPlaceholder = false
        }, 1000)
      }
    },
    fade: {
      enterClass: 'fadeIn',
      leaveClass: 'fadeOut'
    }
  }
}
</script>

<style scoped>
  .animated {
    animation-duration: .6s;
  }
  .view-container {
    position: relative;
    overflow: hidden;
  }
  .placeholder {
    position: absolute;
    top: 0;
    right: 0;
    bottom: 0;
    left: 0;
    z-index: 9999;
  }
</style>

<style>
  body {
  }
</style>



/** WEBPACK FOOTER **
 ** App.vue?726bd306
 **/